import { ConferenceType } from '@wui/im'

import { Room } from '@/shared/types/store'

import { callSessionsLayoutsStore, Layouts } from '..'

const getDefaultLayout = (room: Room): Layouts => {
  if (!room?.isGroup) {
    return Layouts.PRIVATE
  }

  if (room.mode === ConferenceType.FREE_FOR_ALL) {
    return Layouts.GRID
  }

  return Layouts.LARGE
}

type SetLayoutOptions = {
  isManual?: boolean
}

export const useCallSessionLayout = () => {
  const {
    layoutsByRoomPServed,
    markLayoutAsManual,
    isLayoutManuallySet,
  } = callSessionsLayoutsStore()

  const initializeCallSessionLayout = (room: Room) => {
    const existedLayout = layoutsByRoomPServed.get(room.pServedUser)
    const layout = existedLayout ?? getDefaultLayout(room)
    layoutsByRoomPServed.set(room.pServedUser, layout)
  }

  const toggleLayout = (roomPServed: string) => {
    const current = layoutsByRoomPServed.get(roomPServed)
    if (!current) {
      layoutsByRoomPServed.set(roomPServed, Layouts.LARGE)
      markLayoutAsManual(roomPServed)
      return
    }

    setLayout(roomPServed, current === Layouts.GRID ? Layouts.LARGE : Layouts.GRID, { isManual: true })
  }

  const setLayout = (roomPServed: string, layout: Layouts, options?: SetLayoutOptions) => {
    layoutsByRoomPServed.set(roomPServed, layout)

    if (options?.isManual) {
      markLayoutAsManual(roomPServed)
    }
  }

  return {
    initializeCallSessionLayout,
    toggleLayout,
    setLayout,
    isLayoutManuallySet,
  }
}
